import { useEffect } from "react";
import { useUIState } from "./uiStateContext";

/** 뒤로가기를 '조용히' 소비(무시) — confirm 없이 완전 차단 */
export default function useStrictBackBlock(when = true) {
  const { registerPageBackHandler } = useUIState();

  useEffect(() => {
    if (!when) return;
    // 아무 것도 하지 않고 소비만
    const unregister = registerPageBackHandler(() => {});
    return () => unregister();
  }, [when, registerPageBackHandler]);
}
